module.exports = __webpack_public_path__ + "static/img/calendar.b2e2b0e1.svg";